import { render, staticRenderFns } from "./ProfitResults.vue?vue&type=template&id=10bd0730&"
import script from "./ProfitResults.vue?vue&type=script&lang=ts&"
export * from "./ProfitResults.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitResults.vue?vue&type=style&index=0&acoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports